// extracted by mini-css-extract-plugin
export var loadingSpinner = "_23-0";
export var spinnerContainer = "_23-1";